import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const PublishedIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M10.1888 9.3335C10.3182 8.45957 10.5084 7.68207 10.7409 7.04254C10.9668 6.42144 11.22 5.96572 11.4675 5.67773C11.717 5.38759 11.8992 5.3335 12 5.3335C12.1008 5.3335 12.283 5.38759 12.5325 5.67773C12.7801 5.96572 13.0332 6.42144 13.2591 7.04254C13.4917 7.68207 13.6818 8.45957 13.8112 9.3335H10.1888Z"
        fill={fillColor || '#111112'}
      />
      <path
        d="M9.88322 5.67657C9.73749 5.95654 9.60584 6.26245 9.48786 6.58688C9.20328 7.36949 8.98261 8.30346 8.84204 9.3335H5.88807C6.63836 7.61626 8.09117 6.27619 9.88322 5.67657Z"
        fill={fillColor || '#111112'}
      />
      <path
        d="M14.1168 5.67657C14.2625 5.95654 14.3942 6.26245 14.5122 6.58688C14.7967 7.36949 15.0174 8.30346 15.158 9.3335H18.112C17.3617 7.61625 15.9089 6.27619 14.1168 5.67657Z"
        fill={fillColor || '#111112'}
      />
      <path
        d="M18.5333 10.6668H15.2908C15.3188 11.101 15.3333 11.5466 15.3333 12.0002C15.3333 12.6892 15.2999 13.3598 15.2364 14.0002H18.3615C18.5598 13.3688 18.6667 12.697 18.6667 12.0002C18.6667 11.5435 18.6208 11.0976 18.5333 10.6668Z"
        fill={fillColor || '#111112'}
      />
      <path
        d="M17.7748 15.3335H15.0535C14.917 16.1013 14.734 16.8034 14.5122 17.4134C14.3942 17.7379 14.2625 18.0438 14.1168 18.3238C15.6696 17.8042 16.9677 16.7286 17.7748 15.3335Z"
        fill={fillColor || '#111112'}
      />
      <path
        d="M12 18.6668C12.1008 18.6668 12.283 18.6127 12.5325 18.3226C12.7801 18.0346 13.0332 17.5789 13.2591 16.9578C13.4307 16.4859 13.5792 15.9389 13.6973 15.3335H10.3028C10.4208 15.9389 10.5693 16.4859 10.7409 16.9578C10.9668 17.5789 11.22 18.0346 11.4675 18.3226C11.717 18.6127 11.8992 18.6668 12 18.6668Z"
        fill={fillColor || '#111112'}
      />
      <path
        d="M9.88322 18.3238C8.33039 17.8042 7.03227 16.7286 6.22522 15.3335H8.94652C9.08302 16.1013 9.26602 16.8034 9.48786 17.4134C9.60584 17.7379 9.73749 18.0438 9.88322 18.3238Z"
        fill={fillColor || '#111112'}
      />
      <path
        d="M5.63855 14.0002H8.76367C8.70017 13.3598 8.66668 12.6892 8.66668 12.0002C8.66668 11.5466 8.68119 11.101 8.70922 10.6668H5.4667C5.37925 11.0976 5.33334 11.5435 5.33334 12.0002C5.33334 12.697 5.44025 13.3688 5.63855 14.0002Z"
        fill={fillColor || '#111112'}
      />
      <path
        d="M10 12.0002C10 12.6984 10.0367 13.3696 10.104 14.0002H13.896C13.9634 13.3696 14 12.6984 14 12.0002C14 11.5428 13.9843 11.0971 13.9545 10.6668H10.0455C10.0157 11.0971 10 11.5428 10 12.0002Z"
        fill={fillColor || '#111112'}
      />
    </svg>
  );
};

export { PublishedIcon };
